/**
 * Compact credentials strip placed high on the page — the at-a-glance reasons to trust
 * the platform before scrolling into the detail. Icon + label, no marketing fluff.
 */
import { ShieldCheck, Lock, FileCheck2, Landmark } from 'lucide-react';
import styles from './TrustStrip.module.css';

const ITEMS = [
  { icon: Landmark, label: 'Section 8 non-profit', sub: 'Registered company' },
  { icon: ShieldCheck, label: 'Ground-verified cases', sub: 'GPS + timestamp proof' },
  { icon: FileCheck2, label: 'Hash-chained audit trail', sub: 'Tamper-evident ledger' },
  { icon: Lock, label: 'DPDP-compliant privacy', sub: 'Aadhaar stored as a hash' },
];

export function TrustStrip() {
  return (
    <section className={styles.strip} aria-label="Trust credentials">
      <div className={`container ${styles.inner}`}>
        {ITEMS.map((it) => (
          <div key={it.label} className={styles.item}>
            <span className={styles.icon}>
              <it.icon size={22} aria-hidden="true" />
            </span>
            <div>
              <strong className={styles.label}>{it.label}</strong>
              <span className={styles.sub}>{it.sub}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default TrustStrip;
